/* RESPONSIBLE TEAM: team-phone */
import ApplicationAdapter from '../application';

export default ApplicationAdapter.extend({
  pathForType() {
    return 'sms/phone_number';
  },
});
